/**
 * ExportButton Component
 * Button for exporting audit logs to CSV
 */

import React from 'react';
import { AuditLogEntry } from '../../types/audit';
import { exportAuditLogsToCSV } from '../../utils/auditExport';

interface ExportButtonProps {
  logs: AuditLogEntry[];
  disabled?: boolean;
}

export const ExportButton: React.FC<ExportButtonProps> = ({
  logs,
  disabled = false,
}) => {
  const handleExport = () => {
    if (logs.length === 0) return;
    exportAuditLogsToCSV(logs);
  };

  return (
    <button
      onClick={handleExport}
      disabled={disabled || logs.length === 0}
      className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      title={logs.length === 0 ? 'No logs to export' : 'Export to CSV'}
    >
      <svg
        className="w-4 h-4 mr-1.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        />
      </svg>
      Export CSV
    </button>
  );
};
